import { useState, useCallback } from 'react'
import { AssetDTO } from 'api-models'
import {
	TabId,
	ServerSideTabState,
	TrackingCodeTabState,
	TrackingMethod,
	ServerSideTrackingState
} from '../types'

export const useTrackingState = (asset: AssetDTO) => {
	const savedState = asset?.server_side_tracking as
		| ServerSideTrackingState
		| undefined

	// Determine initial server-side state from asset data
	const getInitialServerSideState = (): ServerSideTabState => {
		if (savedState?.setupCompleted) return 'completed'
		return 'active'
	}

	const [activeTab, setActiveTab] = useState<TabId>('server-side')
	const [serverSideState, setServerSideState] = useState<ServerSideTabState>(
		getInitialServerSideState
	)
	const [trackingCodeState, setTrackingCodeState] =
		useState<TrackingCodeTabState>('active')
	const [selectedMethod, setSelectedMethod] =
		useState<TrackingMethod | null>(null)

	const resetServerSide = useCallback(() => {
		setServerSideState('active')
		setActiveTab('server-side')
	}, [])

	const skipServerSide = useCallback(() => {
		setServerSideState('skipped')
		setActiveTab('tracking-code')
	}, [])

	const completeServerSide = useCallback(() => {
		setServerSideState('completed')
		setActiveTab('tracking-code')
	}, [])

	const completeTrackingCode = useCallback(() => {
		setTrackingCodeState('completed')
	}, [])

	return {
		activeTab,
		setActiveTab,
		serverSideState,
		trackingCodeState,
		selectedMethod,
		setSelectedMethod,
		resetServerSide,
		skipServerSide,
		completeServerSide,
		completeTrackingCode
	}
}
